var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',_vm._l((_vm.schedules),function(schedule){return _c('b-col',{key:schedule.name,attrs:{"cols":"12","md":_vm.numColumns}},[_c('Schedule',{staticClass:"mb-4",attrs:{"schedule":schedule,"courses":_vm.$store.state.selectedCourses,"showEditButton":_vm.showEditButton,"onUserProfile":_vm.onUserProfile}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }